<template>
  <div class="error-container">
    <HeaderNav />
    <div class="error-content">
      <h1>An error occurred.</h1>
      <p>Sorry, the page you are looking for is currently unavailable.<br/>
      Please try again later.</p>
      <p>If you are the system administrator of this resource then you should check
      the error log for details.</p>
      <p><em>Faithfully yours, anovator.</em></p>
      <div class="error-actions">
        <router-link to="/" class="btn btn-primary">Back to Home</router-link>
        <button @click="goBack" class="btn btn-secondary">Go Back</button>
      </div>
    </div>
    <FooterSection />
  </div>
</template>

<script>
import HeaderNav from '../components/HeaderNav.vue'
import FooterSection from '../components/FooterSection.vue'

export default {
  name: 'Error',
  components: {
    HeaderNav,
    FooterSection
  },
  mounted() {
    document.title = 'Error - anovator | smart body composition analyzer';
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
.error-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.error-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 20px;
  text-align: center;
  color-scheme: light dark;
  width: 35em;
  margin: 0 auto;
  font-family: Tahoma, Verdana, Arial, sans-serif;
}

.error-content h1 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: #333;
}

.error-content p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 15px;
  color: #666;
}

.error-content p:last-of-type {
  font-style: italic;
  margin-bottom: 30px;
}

.error-actions {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: center;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 5px;
  text-decoration: none;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0056b3;
  color: white;
  text-decoration: none;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #545b62;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .error-content {
    width: 90%;
    padding: 30px 15px;
  }
  
  .error-content h1 {
    font-size: 2rem;
  }
  
  .error-content p {
    font-size: 1rem;
  }
  
  .error-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .btn {
    width: 200px;
  }
}

/* 暗色主题支持 */
@media (prefers-color-scheme: dark) {
  .error-content {
    background-color: #1a1a1a;
  }
  
  .error-content h1 {
    color: #fff;
  }
  
  .error-content p {
    color: #ccc;
  }
}
</style>